export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { injured, setting } = this
	let injuredArr = injured.injuredList,
		injuredFormatted = []
	if (!(injuredArr && injuredArr.length > 0)) {
		injuredArr = [{ injuredName: '' }]
	}

	injuredArr.forEach(item => {
		let singleInjured = {
			title: `伤者信息 - ${item.injuredName}`,
			injuredId: item.id,
			injuredName: item.injuredName,
			agreementId: item.agreement && item.agreement.id,
			status: item.agreement && item.agreement.conciliationStatus,
			children: [
				{
					label: '证件类型',
					value: setting.idTypeMap[item.idType],
				},
				{
					label: '证件号',
					value: item.idNo,
				},
				{
					label: '姓名',
					value: item.injuredName,
				},
				{
					label: '性别',
					value: setting.sexMap[item.sex],
				},
				{
					label: '年龄',
					value: item.age,
				},
			],
		}

		if (item && item.injuredPhone) {
			const phone = item.injuredPhone.split(',')
			if (phone.length === 1) {
				singleInjured.children.push({
					label: '伤者电话',
					value: phone[0],
				})
			} else {
				for (const [index, phoneItem] of phone.entries()) {
					singleInjured.children.push({
						label: `伤者电话${index + 1}`,
						value: phoneItem,
					})
				}
			}
		} else {
			singleInjured.children.push({
				label: '伤者电话',
				value: '',
			})
		}

		singleInjured.children.push(
			{
				label: '伤者紧急联系人姓名',
				value: item.emergencyName,
			},
			{
				label: '紧急联系人与伤者关系',
				value: setting.emergencyTypeMap[item.relationShip],
			}
		)

		let emergencyPhones = (item.emergencyPhone || '').split(',')
		emergencyPhones.forEach((item, key) => {
			singleInjured.children.push({
				label: '紧急联系人电话' + (emergencyPhones.length > 1 ? key + 1 : ''),
				value: item,
			})
		})

		injuredFormatted.push(singleInjured)
	})

	return injuredFormatted
}
